import { useCallback, useEffect, useContext, useState } from 'react';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFilterFamilyOptions } from '../../hooks/useFilterFamilyOptions';
import { useFilterFamilySelect } from '../../hooks/useFilterFamilySelect';
import EditorScrollingBodyContainer from './EditorScrollingBodyContainer';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { SideNav, SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorFilterFamilyOptionsSection = () => {
  const {
    selectedFilterFamily,
    selectedFilterFamilyGroup
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    filterFamilyOptions
  } = useFilterFamilyOptions('', false);
  const {
    disabledFilterFamilies,
    onFilterFamilySelect: onFilterFamilyChange
  } = useFilterFamilySelect();
  const {
    resetFilterCategorySelect
  } = useEditorActions();
  const [selectedFilterFamilyOption, setSelectedFilterFamilyOption] = useState();
  const onFilterFamilySelect = useCallback(option => {
    resetFilterCategorySelect(true);
    onFilterFamilyChange(option);
    setSelectedFilterFamilyOption(option);
  }, [onFilterFamilyChange, resetFilterCategorySelect]);
  useEffect(() => {
    if (!selectedFilterFamily && !selectedFilterFamilyGroup && filterFamilyOptions.length > 0 && filterFamilyOptions[0].options.length > 0) {
      const firstOption = filterFamilyOptions[0].options[0];
      onFilterFamilySelect(firstOption);
      setSelectedFilterFamilyOption(firstOption);
    }
  }, [filterFamilyOptions, onFilterFamilySelect, selectedFilterFamily, selectedFilterFamilyGroup]);
  return /*#__PURE__*/_jsx(EditorScrollingBodyContainer, {
    children: filterFamilyOptions.map((optionsGroup, index) => {
      return /*#__PURE__*/_jsx(SideNav, {
        marginBlockStart: index > 0 ? '400' : undefined,
        headingText: optionsGroup.text,
        children: optionsGroup.options.map((option, childIndex) => {
          return /*#__PURE__*/_jsx(SideNavItem, {
            active: (selectedFilterFamilyOption === null || selectedFilterFamilyOption === void 0 ? void 0 : selectedFilterFamilyOption.text) === option.text,
            disabled: disabledFilterFamilies[option.value],
            onClick: () => onFilterFamilySelect(option),
            title: option.text
          }, `${childIndex}-${option.text}`);
        })
      }, `${index}-${optionsGroup.text}`);
    })
  });
};
export default EditorFilterFamilyOptionsSection;